
import { defineComponent } from 'vue';
import numeral from 'numeral';
import { message } from 'ant-design-vue';
import { mapState } from 'vuex';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { addToCart } from '@/api/apis';
import { validateQuantity } from '@/utils/validate';

export default defineComponent({
  name: 'SingleStatusModal',
  emits: ['after-close'],
  props: {
    record: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    isSpare: {
      type: Boolean,
      default: false
    },
    groupId: {
      type: Number,
      default: null
    },
    vehicleId: {
      type: Number,
      default: null
    }
  },
  components: {
    MinusOutlined,
    PlusOutlined
  },
  data() {
    return {
      validateQuantity,
      visible: true,
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        quantity: '1',
        remark: ''
      },
      isAddedToCart: false
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    handleAfterClose() {
      this.$emit('after-close', this.isAddedToCart);
    },
    handleQuantityChange() {
      const quantity = +this.form.quantity;
      if (quantity > 9999) {
        this.form.quantity = '9999';
      }

      if (quantity === 0) {
        this.form.quantity = '1';
      }
    },
    substract() {
      const quantity = Number(this.form.quantity);
      if (!isNaN(quantity) && quantity > 1) {
        this.form = {
          ...this.form,
          quantity: String(quantity - 1)
        } as any;

        const form = (this.$refs as any).form;

        form.clearValidate('quantity');
      }
    },
    add() {
      const quantity = Number(this.form.quantity || 0);
      if (quantity < 9999) {
        this.form = {
          ...this.form,
          quantity: String(quantity + 1)
        } as any;
        const form = (this.$refs as any).form;
        form.clearValidate('quantity');
      }
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addToCart({
            ...this.form,
            quantity: numeral(this.form.quantity).value(),
            customerId: this.userInfo.id,
            modelNum: this.record.modelNum,
            name: this.record.partName,
            partCode: this.record.partCode,
            groupName: this.record.groupName,
            unit: this.record.unit,
            unitPrice: this.record.sellingPrice,
            consignee: this.userInfo.companyName,
            shoppingType: 2,
            groupId: this.groupId,
            vehicleId: this.vehicleId,

            partsId: this.record.id
          });
          if (res.success) {
            this.isAddedToCart = true;
            this.handleCancel();

            message.success(this.$t(res.message));
          }

          this.loading = false;
        })
        .catch();
    }
  }
});
